let store = {
  namespaced: true,
  state: {
    dontClear: false,
    content: {
      patient_name: '',
      is_completed: null,
      doctor_id: null,
      patient_id_alt: '',
      patient_id: '',
      page: 1
    }
  },
  mutations: {
    updatePatientName (state, payload) {
      state.content.patient_name = payload
    },
    updatePatientIdAlt (state, payload) {
      state.content.patient_id_alt = payload
    },
    updatePage (state, payload) {
      state.content.page = payload
    },
    updateIsCompleted (state, payload) {
      state.content.is_completed = payload
    },
    updateDoctorId (state, payload) {
      state.content.doctor_id = payload
    },
    updatePatientId (state, payload) {
      state.content.patient_id = payload
    },
    dontClear (state, payload) {
      state.dontClear = payload
    }
  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/modules/RecordList.js